import script from "./ResourceStatusCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourceStatusCard.vue?vue&type=script&setup=true&lang=js"

import "./ResourceStatusCard.vue?vue&type=style&index=0&id=6085e50c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6085e50c"]])

export default __exports__